<template>
  <v-content>
    <div id="core-view" style="min-height:100%">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-content>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: 'Grocart Admin Panel',
    };
  },
};
</script>

<style>
#core-view {
}
</style>
